import React, { useEffect, useState } from 'react';
import './EquityDashboard.css';
import { getTickers, subscribeToTickers, unsubscribeFromTickers } from '../../lib/api';
import StockWidget from './StockWidget'; // Ensure StockWidget is imported
import { createLogger } from '../../utils/logger';

const log = createLogger('EquityDashboard');

const EquitiesDashboard = ({ selectedStock, setSelectedStock }) => {
    const [tickers, setTickersState] = useState(() => {
        const fetched = getTickers();
        return Array.isArray(fetched) ? fetched : [];
    });

    useEffect(() => {
        const handleTickerUpdate = (newTickers: string[]) => {
            log.debug('Tickers updated via set_tickers', { newTickers });
            setTickersState(newTickers);
        };

        subscribeToTickers(handleTickerUpdate);
        return () => {
            unsubscribeFromTickers(handleTickerUpdate);
        };
    }, []);

    const handleStockClick = (ticker) => {
        setSelectedStock(ticker);
    };

    return (
        <div className="equities-dashboard">
            <div className="tickers-container">
                {tickers.length > 0 ? (
                    tickers.map((ticker) => (
                        <div
                            key={ticker}
                            className={`stock-item ${selectedStock === ticker ? 'selected' : ''}`}
                            onClick={() => handleStockClick(ticker)}
                        >
                            <StockWidget ticker={ticker} selected={selectedStock === ticker} />
                        </div>
                    ))
                ) : (
                    <p> No tickers available </p>
                )}
            </div>
        </div>
    );
};

export default EquitiesDashboard;
